export const MODULE_NAME = 'views/cottage-list'

export const COTTAGE_LIST_MAP_ROUTE_NAME = 'cottage-list-map'
